/**
 * Module to provide the translations.
 */
export const i18n = {

  /**
   * the url of the language modules
   * @type String
   */
  url: '../locales',

  /**
   * contains the translations
   * @type Object[]
   */
  _resources: [],

  /**
   * Loads the corresponding language module.
   * @param {String} language
   * @returns {Promise}
   */
  async init (language) {
    const url = this.url + '/' + language + '.js';
    const module = await import(url);
    this._resources = module[language];
  },

  /**
   * Return the HTML language attribute.
   * @return {string}
   */
  getLang() {
    return document.querySelector('html').lang;
  },

  /**
   * Translate a text.
   * @param {String} text
   * @returns {String} translated text or fallback
   */
  t (text) {
    let result = text;
    const translation = this._resources[text];
    if (typeof translation === 'undefined') {
      console.error('Translation missing for string: ' + text);
    } else {
      result = translation;
    }
    return result;
  }
};